import { EXPORT_STATUS_HEIGHT } from 'helpers/globals'
import contextMenu from 'helpers/styles/contextMenu'

export default {
  ...contextMenu,
  map: {
    height: ({ exporting }) => exporting ? `calc(100vh - 67px - ${EXPORT_STATUS_HEIGHT}px)` : `calc(100vh - 67px)`
  },
  mobileMap: {
    height: '100%'
  },
  mapContainer: {
    position: 'relative',
    flex: '1 1 auto',
    height: 'calc(100vh - 67px)',
    zIndex: 2,
    minBlockSize: 0
  },
  overviewMapContainer: {
    height: '100vh',
    width: '100vw'
  },
  exportMap: {
    zIndex: 5,
    height: 'calc(100vh - 108px)'
  },
  overviewMap: {
    zIndex: 5,
    height: '100vh'
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/style.js